import { Flame } from "lucide-react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-[#090D16] flex items-center justify-center p-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-emerald-500/10 via-transparent to-transparent pointer-events-none" />
      <div className="w-full max-w-md relative animate-fade-up">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <div className="w-11 h-11 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center shadow-[0_0_25px_rgba(16,185,129,0.25)]">
            <Flame className="w-6 h-6 text-emerald-400" />
          </div>
          <div>
            <span className="font-heading font-extrabold text-2xl tracking-tight text-slate-50">MaturaMax</span>
            <span className="block text-[11px] text-slate-500 -mt-0.5 tracking-wide">maturamax.com.br</span>
          </div>
        </div>
        <div className="backdrop-blur-md bg-slate-900/80 border border-slate-800/80 shadow-2xl rounded-xl p-6 sm:p-8">
          <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-100">{title}</h1>
          {subtitle && <p className="text-sm text-slate-400 mt-1.5 leading-relaxed">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="mt-5 text-center text-sm text-slate-400">{footer}</div>}
      </div>
    </div>
  );
}
